export function LoadingSpinner({ label = "Loading..." }: { label?: string }): JSX.Element {
  return (
    <div className="flex animate-fade-in flex-col items-center justify-center gap-3 py-12 text-slate-500 dark:text-slate-400">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-brand-600 dark:border-slate-600 dark:border-t-brand-400" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
